import styled from "styled-components";
import {
    Typography,
    Row,
    Col,
    Card,
    Button,
    Popconfirm,
    Tag,
    Divider,
    Space,
    message,
    Input,
    Select,
    Menu,
    Layout,
    Avatar,
} from "antd";
import {
    CheckCircleOutlined,
    DeleteOutlined,
    UserOutlined,
    PlayCircleOutlined,
    MenuUnfoldOutlined,
    MenuFoldOutlined,
    LogoutOutlined as UserIcon,
} from "@ant-design/icons";
import React, {useState} from "react";
import axios from "axios";
import {BASE_URL} from "../home/BASE_URL";
import {useSelector} from "react-redux";
import {clearAdminUserDetails} from "../store/reducer";

const {Title, Text, Paragraph, Link} = Typography;
const {Option} = Select;
const {Header, Sider, Content} = Layout;

const Wrapper1 = styled(Layout)`
    min-height: 100vh;
    max-width: 1200px;
    margin: auto;
`;

const StyledTitle = styled(Title)`
    color: white !important;
`;

const StyledCard = styled(Card)`
    border-radius: 12px;
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.05);
    transition: all 0.3s ease;

    &:hover {
        box-shadow: 0 12px 24px rgba(0, 0, 0, 0.1);
    }

    .ant-card-cover img {
        height: 250px;
        object-fit: cover;
        border-top-left-radius: 12px;
        border-top-right-radius: 12px;
    }

    .ant-card-actions {
        background-color: #fafafa;
        border-top: 3px solid #f0f0f0;
    }
`;

const DemoLink = styled(Link)`
    display: inline-flex;
    align-items: center;
    margin-top: 8px;
    font-weight: 500;
    color: #722ed1;

    &:hover {
        color: #9254de;
    }

    svg {
        margin-right: 5px;
    }
`;

const Container = styled.div`
    background-color: rgb(31, 1, 16);
`;

const ArtistCard = ({artist, onApprove, onDelete, isDeletedTab}) => (
    <StyledCard
        hoverable
        cover={<img alt={artist.stageName} src={artist.profileImage} />}
        actions={[
            <Button
                type="primary"
                icon={<CheckCircleOutlined />}
                disabled={artist.approved || isDeletedTab}
                onClick={() => onApprove(artist._id)}
            >
                {artist.approved ? "Approved" : "Approve"}
            </Button>,
            <Popconfirm
                title="Are you sure you want to delete this artist application?"
                onConfirm={() => onDelete(artist._id)}
                okText="Yes"
                cancelText="No"
                disabled={isDeletedTab}
            >
                <Button type="primary" danger icon={<DeleteOutlined />} disabled={isDeletedTab}>
                    Delete
                </Button>
            </Popconfirm>,
        ]}
    >
        <Space direction="vertical" size="small" style={{width: "100%", margin: "-12px"}}>
            <Title level={4} style={{marginBottom: 0}}>
                <UserOutlined /> {artist.stageName}
            </Title>
            <Text>
                Gender: <Tag color="blue">{artist.gender}</Tag>
            </Text>
            <Text>
                Genre: <Tag color="purple">{artist.genre}</Tag>
            </Text>
            <Text>
                Real Name: <Tag color="blue">{artist.realName}</Tag>
            </Text>
            <Text>
                Email: <Tag color="purple">{artist.email}</Tag>
            </Text>
            <Paragraph ellipsis={{rows: 1, expandable: true}}>{artist.bio}</Paragraph>
            <Divider style={{margin: "0"}} />
            <div>
                {artist.spotify && (
                    <Tag color="blue">
                        <Link href={artist.spotify} target="_blank">
                            Spotify
                        </Link>
                    </Tag>
                )}
                {artist.audiomack && (
                    <Tag color="gold">
                        <Link href={artist.audiomack} target="_blank">
                            Audiomack
                        </Link>
                    </Tag>
                )}
            </div>
            {artist.demoFile && (
                <DemoLink href={artist.demoFile} target="_blank">
                    <PlayCircleOutlined /> Listen to Demo
                </DemoLink>
            )}
        </Space>
    </StyledCard>
);

export default function ArtistList() {
    const [artists, setArtists] = useState([]);
    const [approvedArtists, setApprovedArtists] = useState([]);
    const [deletedArtists, setDeletedArtists] = useState([]);

    const [collapsed, setCollapsed] = useState(true);
    const [activeTab, setActiveTab] = useState("pending");
    const [searchText, setSearchText] = useState("");
    const [genderFilter, setGenderFilter] = useState("All");
    const {adminUserDetails} = useSelector((state) => state.admin);
    const token = adminUserDetails.token;

    // const fetchArtists = async () => {
    //     try {
    //         const res = await axios.get(`${BASE_URL}/artists?approved=false`, {
    //             headers: {
    //                 Authorization: `Bearer ${token}`,
    //             },
    //         });
    //         if (res.data) {
    //             setArtists(res.data);
    //             console.log(res.data);
    //         } else {
    //             message.error("Error fetching artists.");
    //         }
    //     } catch {
    //         message.error("Error fetching artists.");
    //     }
    // };

    // const fetchApproved = async () => {
    //     try {
    //         const res = await axios.get(`${BASE_URL}/artists?approved=true`, {
    //             headers: {
    //                 Authorization: `Bearer ${token}`,
    //             },
    //         });

    //         if (res.data) {
    //             setApprovedArtists(res.data);
    //         } else {
    //             message.error("Error fetching artists.");
    //         }
    //     } catch (err) {
    //         console.error(err);
    //     }
    // };

    const fetchDeletedArtists = async () => {
        try {
            const response = await axios.get(`${BASE_URL}/artists/deleted`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (response.data) {
                setDeletedArtists(response.data);
            } else {
                message.error("Error fetching artists.");
            }
        } catch (err) {
            console.error("Error fetching deleted artists:", err);
        }
    };

    // useEffect(() => {
    //     if (activeTab === "pending") {
    //         fetchArtists();
    //     } else if (activeTab === "approved") {
    //         fetchApproved();
    //     } else if (activeTab === "deleted") {
    //         fetchDeletedArtists();
    //     }
    // }, [activeTab]);

    // useEffect(() => {
    //     fetchArtists();
    //     fetchApproved();
    // }, []);

    const handleApprove = async (id) => {
        try {
            const res = await axios.patch(
                `${BASE_URL}/artists/${id}/approve`,
                {},
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            const approvedArtist = res.data;

            if (res.data) {
                setArtists((prev) => prev.filter((a) => a._id !== id));
                setApprovedArtists((prev) => [...prev, approvedArtist]);
                message.success("Artist approved and moved to Approved list");
            } else {
                message.error("Approval failed");
            }
        } catch {
            message.error("Approval failed");
        }
    };

    const handleDelete = async (id) => {
        try {
            const res = await axios.delete(`${BASE_URL}/artists/${id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (res.data) {
                setArtists((prev) => prev.filter((a) => a._id !== id));
                setApprovedArtists((prev) => prev.filter((a) => a._id !== id));
                await fetchDeletedArtists();
                message.success("Artist deleted.");
            } else {
                message.error("Failed to delete artist.");
            }
        } catch {
            message.error("Failed to delete artist.");
        }
    };

    const filteredList = () => {
        const list = activeTab === "pending" ? artists : activeTab === "approved" ? approvedArtists : deletedArtists;

        return list.filter(
            (artist) =>
                (genderFilter === "All" || artist.gender === genderFilter) &&
                artist.stageName?.toLowerCase().includes(searchText.toLowerCase())
        );
    };

    return (
        <Container>
            <Wrapper1>
                <Sider trigger={null} collapsible collapsed={collapsed} style={{background: "#1f0110"}}>
                    <div
                        style={{
                            height: 64,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            color: "white",
                            fontSize: 18,
                        }}
                    >
                        {collapsed ? (
                            <Button
                                type="text"
                                icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                                onClick={() => setCollapsed(!collapsed)}
                                style={{fontSize: "16px", color: "#fff"}}
                            />
                        ) : (
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    gap: "30px",
                                    alignItems: "center",
                                }}
                            >
                                <span>XTIIM Admin</span>
                                <Button
                                    type="text"
                                    icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                                    onClick={() => setCollapsed(!collapsed)}
                                    style={{fontSize: "16px", color: "#fff"}}
                                />
                            </div>
                        )}
                    </div>
                    <Menu
                        style={{
                            display: "flex",
                            flexDirection: "column",
                        }}
                        theme="dark"
                        mode="inline"
                        selectedKeys={[activeTab]}
                        onClick={(e) => setActiveTab(e.key)}
                        items={[
                            {key: "pending", label: "Pending"},
                            {key: "approved", label: "Approved"},
                            {key: "deleted", label: "Deleted"},
                        ]}
                    />
                </Sider>
                <Layout style={{backgroundColor: "rgb(31, 1, 16)"}}>
                    <Header
                        style={{
                            padding: "0 10px",
                            background: "#1f0110",
                            display: "flex",
                            alignItems: "center",
                            flexWrap: "wrap",
                        }}
                    >
                        <div style={{marginLeft: "auto", display: "flex", gap: "10px"}}>
                            <Input.Search
                                placeholder="Search artist..."
                                style={{width: "100%"}}
                                onChange={(e) => setSearchText(e.target.value)}
                            />
                            <Select defaultValue="All" style={{width: "100%"}} onChange={(val) => setGenderFilter(val)}>
                                <Option value="All">All</Option>
                                <Option value="Male">Male</Option>
                                <Option value="Female">Female</Option>
                            </Select>
                            <Avatar icon={<UserIcon onClick={clearAdminUserDetails()} />} />
                        </div>
                    </Header>
                    <Content style={{margin: "10px", color: "white"}}>
                        <StyledTitle level={4}>{activeTab.toUpperCase()} Artists</StyledTitle>
                        {/* <Spin spinning={loading && activeTab !== "deleted"} tip="Loading artists..."> */}
                        <Row gutter={[12, 12]}>
                            {filteredList().map((artist) => (
                                <Col xs={24} sm={12} lg={8} key={artist._id} style={{minWidth: 250}}>
                                    <ArtistCard
                                        artist={artist}
                                        onApprove={handleApprove}
                                        onDelete={handleDelete}
                                        isDeletedTab={activeTab === "deleted"}
                                    />
                                </Col>
                            ))}
                        </Row>
                        {/* </Spin> */}
                    </Content>
                </Layout>
            </Wrapper1>
        </Container>
    );
}
